import { render, staticRenderFns } from "./InstantPayouts.vue?vue&type=template&id=09541b9b"
import script from "./InstantPayouts.vue?vue&type=script&lang=js"
export * from "./InstantPayouts.vue?vue&type=script&lang=js"
import style0 from "./InstantPayouts.vue?vue&type=style&index=0&id=09541b9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports